import { FeatureFlagSwitch } from "../FeatureFlagSwitch/FeatureFlagSwitch";
import { Flags } from "../../../feature-flags/flags";
import { UserGroupMultiFilterDropdown } from "../UserGroupMultiFilterDropdown/UserGroupMultiFilterDropdown";
import { UserGroupFilterDropdown } from "../UserGroupFilterDropdown/UserGroupFilterDropdown";

export const GroupTypeFilter = ({
    hideProductGroupFilter = false,
    onChange,
    selectedGroupTypes = []
}: {
    hideProductGroupFilter?: boolean;
    onChange: (value: string[]) => void;
    selectedGroupTypes?: string[];
}) => {
    const handleSingleGroupTypeChange = (groupType: string) => {
        onChange([groupType]);
    };

    return (
        <FeatureFlagSwitch
            featureFlag={Flags.ENABLE_MULTISELECT_GROUP_TYPE_FILTERS}
            onElement={
                <UserGroupMultiFilterDropdown
                    appliedGroupTypes={selectedGroupTypes}
                    onChange={onChange}
                    data-cy="group-type-filter"
                />
            }
            offElement={
                <UserGroupFilterDropdown
                    selectedGroupType={selectedGroupTypes[0]}
                    selectGroupType={handleSingleGroupTypeChange}
                    hideProductGroup={hideProductGroupFilter}
                    data-cy="group-type-filter"
                />
            }
        />
    );
};

GroupTypeFilter.displayName = "GroupTypeFilter";
